import z from "zod/v4";
import { kellyDisplaySchema, oddsFormatSchema } from "./generated-schemas.js";
const subscriptionStateSchema = z.object({
    hasPro: z.boolean().optional(),
    hasPlus: z.boolean().optional(),
    hasPremium: z.boolean().optional(),
    proExpiration: z.string().nullish(),
    didTrial: z.boolean().nullish(),
    onTrial: z.boolean().nullish(),
    activeStore: z.string().nullish(),
});
export const userInfoSchema = z.object({
    userId: z.string(),
    website: z.string().nullish(),
    twitter: z.string().nullish(),
    name: z.string().nullish(),
    intercomUserHash: z.string().nullish(),
    subscriptionState: subscriptionStateSchema,
    email: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    discord: z.string().nullish(),
    avatar: z.string().nullish(),
    createdDate: z.string(),
    signInMethod: z.string(),
    origination: z.string().optional(),
    rcBypass: z.boolean(),
    oddsFormat: oddsFormatSchema.optional(),
    kellyDisplay: kellyDisplaySchema.optional(),
    bankroll: z.number().optional(),
});
